import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize the root with error boundary protection
const root = ReactDOM.createRoot(document.getElementById('root'));

// Add a global error handler to catch and log errors securely
window.addEventListener('error', (event) => {
  // In production, you would send to a secure error logging service
  console.error('Application error:', event.error ? event.error.message : 'Unknown error');
  // Prevent default browser error handling
  event.preventDefault();
});

// Enable strict mode for development
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enable performance measurement without logging sensitive data
// Send only aggregated metrics without PII
const sendToAnalytics = (metric) => {
  // Implementation would filter out PII and send to secure endpoint
  // For now, we just log it securely
  if (process.env.NODE_ENV === 'production') {
    // Only log non-PII data in production
    const sanitizedMetric = {
      id: metric.id,
      name: metric.name,
      value: metric.value,
      // Don't include user-specific identifiers
    };
    console.debug('Performance metric:', sanitizedMetric);
  }
};

// Enable performance monitoring with secure analytics
reportWebVitals(sendToAnalytics);
